export default __webpack_public_path__ + "static/media/stoquate_normal-available_loan-mobile.08601887.jpg";